import React from "react";

const TetherERCIcon = ({ className }) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    overflow="visible"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(16 17) scale(1.7) translate(-16 -16)">
      <path
        d="M9.97961 7.33301H22.2674C22.5606 7.33301 22.8314 7.48494 22.9777 7.73142L26.5577 13.7661C26.7432 14.0791 26.6882 14.4741 26.4233 14.7278L16.5694 24.1714C16.2502 24.4773 15.7367 24.4773 15.4175 24.1714L5.57701 14.7406C5.30605 14.4809 5.25531 14.0744 5.45456 13.7595L9.28122 7.71206C9.43026 7.47654 9.69472 7.33301 9.97961 7.33301Z"
        fill="#69AC96"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6808 10.0273V11.7205H17.1805V12.8945C19.6389 13.0199 21.4833 13.5352 21.497 14.1528L21.4969 15.4403C21.4832 16.0579 19.6389 16.5732 17.1805 16.6986V19.5797H14.8563V16.6986C12.3979 16.5732 10.5535 16.0579 10.5398 15.4403L10.5399 14.1528C10.5536 13.5352 12.3979 13.0199 14.8563 12.8945V11.7205H11.356V10.0273H20.6808ZM16.0184 15.8141C18.6419 15.8141 20.8347 15.3784 21.3714 14.7966C20.9163 14.3032 19.2703 13.9148 17.1805 13.8082V15.0373C16.806 15.0565 16.4172 15.0665 16.0184 15.0665C15.6196 15.0665 15.2308 15.0565 14.8563 15.0373V13.8082C12.7666 13.9148 11.1205 14.3032 10.6654 14.7966C11.2021 15.3784 13.3949 15.8141 16.0184 15.8141Z"
        fill="white"
      />
    </g>

    <g
      transform="translate(1 -3)"
      clipPath="url(#clip0_1364_7135)"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9648 18C28.7449 18 30.4849 18.5278 31.965 19.5168C33.445 20.5057 34.5986 21.9113 35.2798 23.5558C35.9609 25.2004 36.1392 27.01 35.7919 28.7558C35.4446 30.5016 34.5875 32.1053 33.3288 33.364C32.0701 34.6226 30.4665 35.4798 28.7207 35.8271C26.9748 36.1743 25.1652 35.9961 23.5207 35.3149C21.8762 34.6337 20.4706 33.4802 19.4816 32.0001C18.4927 30.5201 17.9648 28.78 17.9648 27C17.9648 24.6131 18.9131 22.3239 20.6009 20.636C22.2887 18.9482 24.5779 18 26.9648 18Z"
        fill="#CDCDCD"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9646 19.9326L29.3325 23.4704L31.7003 27.0091L26.9646 29.3949L22.229 27.0001L24.5968 23.4614L26.9646 19.9326ZM26.9646 30.3481L22.4916 27.9614L26.9646 34.0675L31.4376 27.9614L26.9646 30.3481Z"
        fill="#343434"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9648 19.9326L29.3327 23.4614L31.7005 27.0001L26.9648 25.2123V19.9326Z"
        fill="#343434"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9648 30.3476L31.4468 27.9609L26.9648 34.076V30.3476Z"
        fill="#313131"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9648 25.2119L31.7005 26.9996L26.9648 29.3855V25.2119Z"
        fill="#151515"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9646 19.9326L24.5968 23.4614L22.229 27.0001L26.9646 25.2123V19.9326Z"
        fill="#8C8C8C"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9647 30.3476L22.4917 27.9609L26.9647 34.076V30.3476Z"
        fill="#8A8A8A"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9646 25.2119L22.229 26.9996L26.9646 29.3855V25.2119Z"
        fill="#353535"
      />
    </g>

    <defs>
      <clipPath id="clip0_1364_7135">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(18 18)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default TetherERCIcon;
